import React from 'react';
import './Preloader.scss';

const Preloader = () => {
  return (
    <div className="st-preloader st-flex-center">
      <div className="st-preloader-in"></div>
    </div>
  );
};

export default Preloader;